module.exports = __webpack_public_path__ + "img/24.d15ee6bf.jpg";